import { Button } from '@monksflow/monks-ui';
import { SparklesIcon } from 'lucide-react';
import type { PageAgentIntroContent } from '../../model/page-agent';
import { AgentIntro } from '../AgentIntro';

interface PageAgentIntroProps extends PageAgentIntroContent {
  /** Puts a prompt in the composer for the person to finish, rather than sending it. */
  onPrompt: (prompt: string) => void;
}

/** A page agent before its first message, introduced as Flow.Assist is, with prompts to start from. */
export function PageAgentIntro({ title, description, prompts, onPrompt }: PageAgentIntroProps) {
  return (
    <AgentIntro
      // The badge tokens the composer's own agent avatar is drawn in, so the two read as one agent.
      icon={<SparklesIcon className="size-8 text-badge-purple-foreground" aria-hidden />}
      tagBackground="var(--badge-purple)"
      title={title}
      description={description}
      className="min-h-full py-lg"
    >
      {prompts.length > 0 && (
        <div className="flex w-full flex-col gap-xs">
          {prompts.map((prompt) => (
            <Button
              key={prompt}
              variant="outline"
              size="sm"
              className="w-full justify-start"
              onClick={() => onPrompt(prompt)}
            >
              {prompt}
            </Button>
          ))}
        </div>
      )}
    </AgentIntro>
  );
}
